// extracted by mini-css-extract-plugin
export var background = "_72-0";
export var container = "_72-1";
export var contentItem = "_72-7";
export var extendedWarranty = "_72-5";
export var link = "_72-d";
export var modal = "_72-b";
export var modalCloseButton = "_72-9";
export var modalContent = "_72-3";
export var modalContentMain = "_72-6";
export var modalImageLogo = "_72-8";
export var modalLogo = "_72-a";
export var modalSideImage = "_72-4";
export var preview = "_72-c";
export var redoModal = "_72-2";